module.exports = __webpack_public_path__ + "img/07.db407412.png";